module.exports = __webpack_public_path__ + "static/img/duom05.b0bad8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/duom05.png
// module id = 981
// module chunks = 0